

export default {
  name: "color",
  nickname: "颜色",
  desc: "color",
  eType: "",
  type: "array",
  simpleArray: true,
  value: [
    "#c23531",
    "#2f4554",
    "#61a0a8",
    "#d48265",
    "#91c7ae",
    "#749f83",
    "#ca8622",
    "#bda29a",
    "#6e7074",
    "#546570",
    "#c4ccd3",
  ],
  defaultValue: [
    "#c23531",
    "#2f4554",
    "#61a0a8",
    "#d48265",
    "#91c7ae",
    "#749f83",
    "#ca8622",
    "#bda29a",
    "#6e7074",
    "#546570",
    "#c4ccd3",
  ],
  props: {
    value: {
      type: "color",
      nickname: "颜色",
      desc: "",
      value: "",
      defaultValue: "",
    },
  },
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "CL",
}
